<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v"></a><strong>CONTENTS</strong></h2>
<p class="toc-entry"><a href="#/html/9780292733787_06_int#lev001">Introduction</a></p>
<p class="toc-entryt"><a href="#/html/9780292733787_08_ch1#lev002">By Meat Alone</a></p>
<p class="toc-entry"><a href="#/html/9780292733787_09_ch2#lev003">The Dynasticks</a></p>
<p class="toc-entry"><a href="#/html/9780292733787_10_ch3#lev004">Mystery Money</a></p>
<p class="toc-entry"><span href="#/html/9780292733787_11_ch4#lev005" title="Link target outside of Sample">Bad Language</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_12_ch5#lev006" title="Link target outside of Sample">Scouting Sleepers</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_13_ch6#lev007" title="Link target outside of Sample">Confessions of a Speechwriter/And Especially to Pickens, S.C.</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_14_ch7#lev008" title="Link target outside of Sample">Knowing Johnny Jenkins</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_15_ch8#lev009" title="Link target outside of Sample">If the Boot Fits</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_16_ch9#lev010" title="Link target outside of Sample">New Cheerleaders</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_17_ch10#lev011" title="Link target outside of Sample">Whose Mines Are They?</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_18_ch11#lev012" title="Link target outside of Sample">Not Super-Outrageous</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_19_ch12#lev013" title="Link target outside of Sample">Three Texans in Six Lines</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_20_ch13#lev014" title="Link target outside of Sample">Making Adjustments</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_21_ch14#lev015" title="Link target outside of Sample">Presidential Ups and Downs: Washington Pundits Take Their Analytical Skills to the Ranch</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_22_ch15#lev016" title="Link target outside of Sample">The Life and Times of Joe Bob Briggs, So Far</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_23_ch16#lev017" title="Link target outside of Sample">One Texan in Eight Lines</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_24_ch17#lev018" title="Link target outside of Sample">Reformer</span></p>
<p class="toc-entry"><span href="#/html/9780292733787_25_ch18#lev019" title="Link target outside of Sample">Molly Ivins, R.I.P.</span></p>
<p class="toc-entryt"><span href="#/html/9780292733787_26_bm#lev020" title="Link target outside of Sample">Credits</span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292733787_05_toc.vue?75dc5aa4